module.exports = __webpack_public_path__ + "img/1125.ad815e93.gif";